export default "__VITE_ASSET__C9Ta2Ev4__"